import { FieldName } from 'react-hook-form';

import { ICD9Procedure } from '@dreryk/egabinet-icd-dictionary-frontend-api';

import { Bean, BindingCreator, TranslatableText, ValidationRules } from '@dreryk/react-common';
import { Autosuggest, TestId } from '@dreryk/react-components';

import { procedureSelectorTranslationKeys } from '../translations';

import { createIcd9ProceduresSearchCreator, itemRenderer, procedureLabelExtractor } from './ProcedureAutosuggest.utils';

type ProceduresAutosuggestProps<NAME extends string, FORM_BEAN_PART extends Bean> = {
   readonly register: BindingCreator<FORM_BEAN_PART>;
   readonly name: NAME;
   readonly dictionaryValidOn: Date;
   readonly defaultValue?: ICD9Procedure | null;
   readonly onSelectionChange?: (selectedProcedure: ICD9Procedure | null) => void;
   readonly validationRules?: ValidationRules<Bean>;
   readonly label?: TranslatableText;
   readonly className?: string;
   readonly testId?: TestId;
};

export const ProcedureAutosuggest = <NAME extends string, FORM_BEAN_PART extends Bean>(
   props: ProceduresAutosuggestProps<NAME, FORM_BEAN_PART>
): JSX.Element => {
   return (
      <Autosuggest<ICD9Procedure>
         placeholder={procedureSelectorTranslationKeys.selectorPlaceholder}
         horizontal={false}
         controller={props.register((props.name as unknown) as FieldName<FORM_BEAN_PART>, props.validationRules)}
         searchCreator={createIcd9ProceduresSearchCreator(props.dictionaryValidOn)}
         itemRenderer={itemRenderer}
         onSelectionChange={props.onSelectionChange}
         labelExtractor={procedureLabelExtractor}
         keyProperty={'code'}
         minChars={2}
         label={props.label}
         defaultValue={props.defaultValue}
         testId={props.testId ?? 'procedure'}
         className={props.className}
      />
   );
};
